import gqlmin from 'gqlmin'
import { datoRateLimitedRequest, transformCollection } from '@/src/utils/contentful'
import {
  datoCustomerContentQuery,
  datoCustomerContentQueryFallback
} from '@/src/queries/query-customer'

export async function getCustomerContent(locale, slug, marketId) {
  try {
    let data = null
    data = await datoRateLimitedRequest(gqlmin(datoCustomerContentQuery), {
      marketId: [marketId],
      locale,
      slug
    })

    // Fallback to English: Case where customer's slug is not available in the requested locale
    if (!data || !data.customerModel) {
      data = await datoRateLimitedRequest(gqlmin(datoCustomerContentQueryFallback), {
        marketId: [marketId],
        locale: locale,
        slug
      })
    }

    return data.customerModel
  } catch (e) {
    if (e.response?.data?.customerModel) {
      return transformCollection(e.response.data.customerModel)
    }
    console.error('Error Fetching Customer Content: ', e)
  }
}

export async function getCustomerLogosByListOfIds(listOfIds = []) {
  const query = `
  query getCustomerLogosByListOfIds($listOfIds: [ItemId]!) {
    allCustomerModels(filter: {id: {in: $listOfIds}}) {
      id
      logo {
        title
        width
        height
        url
      }
    }
}`

  const response = await fetch('/api/dato-fetch', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        listOfIds: listOfIds
      }
    })
  })

  const res = await response.json()

  return res.allCustomerModels || []
}
